import InputBoilerplate from '../InputBoilerplate'
import './LinkInput.css'

function LinkInput({value, setState , label, placeholder}) {
  return (
    <InputBoilerplate 
        label={label}
        type='url'
        value={value}
        placeholder={placeholder}
        setState={setState}
    />
  )
}

export default LinkInput